import { BIM360ProjectService } from "../BIM360ProjectService";
export class FrontendBIM360ProjectServices {
    public services : BIM360ProjectService[] = [
        { name: "project_administration", access_level: "none" }, //admin
        { name: "document_management", access_level: "none" }, // user | admin
    ].map(p => BIM360ProjectService.fromAutodeskJSON(p));

    public toJSON() {
        return this.services.filter(p => p.access_level !== "none");
    }

    public static fromJSON(jsonArray: any): FrontendBIM360ProjectServices
    {
        let s = new FrontendBIM360ProjectServices();
        if(jsonArray && jsonArray.length) {
            const serviceMap = new Map(jsonArray.map(p => [p.name, p.access_level]));
            s.services = s.services.map(defaultService=> ({
                name: defaultService.name,
                access_level: serviceMap.get(defaultService.name) ?? "none"
            })).map(p => BIM360ProjectService.fromAutodeskJSON(p));
        }
        return s;
    }
}